var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralCertificationError = function SvgGeneralCertificationError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.5,
    fill: "#E03131"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.255 5.7h-2.46l.196 7.94h2.067zm-2.568 10.754c0 .722.591 1.288 1.338 1.288.746 0 1.337-.566 1.337-1.288s-.59-1.288-1.337-1.288-1.338.566-1.338 1.288",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralCertificationError;